export interface IForm {
    VariavelNo: number;
    ValorDado: string;
}
